import { useEffect, useState } from 'react';

/** Compte à rebours basé sur le temps serveur (ms restants). */
export function useEvaluationCountdown(remainingMs: number | null | undefined, onExpire?: () => void) {
  const hasTimer = remainingMs != null;
  const [displayMs, setDisplayMs] = useState(() => (remainingMs != null ? remainingMs : 0));

  useEffect(() => {
    if (remainingMs == null) {
      setDisplayMs(0);
      return;
    }
    setDisplayMs(remainingMs);
  }, [remainingMs]);

  useEffect(() => {
    if (!hasTimer || displayMs <= 0) return undefined;
    const timer = window.setInterval(() => {
      setDisplayMs((prev) => {
        const next = Math.max(0, prev - 1000);
        if (next === 0) onExpire?.();
        return next;
      });
    }, 1000);
    return () => window.clearInterval(timer);
  }, [hasTimer, displayMs > 0, onExpire]);

  const totalSeconds = Math.ceil(Math.max(0, displayMs) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const label =
    hours > 0
      ? `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      : `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  return {
    displayMs,
    label,
    hasTimer,
    /** Vrai uniquement si un chronomètre était actif et a atteint zéro. */
    isExpired: hasTimer && displayMs <= 0,
  };
}
